<template>
  <el-upload
    class="upload-demo"
    drag
    action="http://yanghang.site/hide/upload"
    accept=".jpg, .png"
    :before-upload="beforeUpload"
    :show-file-list="true"
    :on-change="handleChange"
    :file-list="fileList"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">
      Drop file here or <em>click to upload</em>
    </div>
    <template #tip>
      <div class="el-upload__tip">jpg/png files only</div>
    </template>
  </el-upload>
  <display v-show="isShow" />
</template>

<script>
import { ref, provide } from "vue";
import { ElMessage } from "element-plus";
import Display from "./Display.vue";
import "animate.css";
export default {
  name: "Upload",
  components: {
    Display,
  },
  setup() {
    let isShow = ref(true);
    let result = ref("");
    let showResult = ref(false);
    let img1 = ref(false);
    let img2 = ref(false);
    let fileList = ref([]);
    let imgNum = ref(0)
    let img1size1 = ref(0)
    let img1size2 = ref(0)
    let img2size1 = ref(0)
    let img2size2 = ref(0)

    provide("result", result);
    provide("showResult", showResult);
    provide("img1", img1);
    provide('img2', img2)
    provide('img1size1', img1size1)
    provide('img1size2', img1size2)
    provide('img2size1', img2size1)
    provide('img2size2', img2size2)
    

    function compress(fileObj) {
      let reader = new FileReader();
      reader.readAsDataURL(fileObj);
      reader.onload = function (e) {
        let image = new Image(); //新建一个img标签（还没嵌入DOM节点)
        image.src = e.target.result;
        image.onload = function () {
          let canvas = document.createElement("canvas"),
          data = e.target.result

          if (imgNum.value == 0){
            img1.value = data;
            img1size1.value = image.width
            img1size2.value = image.height
            imgNum.value = 1;
          } else if (imgNum.value == 1) {
            img2.value = data
            img2size1.value = image.width
            img2size2.value = image.height
            imgNum.value = 2
          }  else {
            img1.value = img2.value
            img1size1.value = img2size1.value
            img1size2.value = img2size2.value
            img2size1.value = image.width
            img2size2.value = image.height
            img2.value = data
          }
      //    updateResult();
        };
      };
    }

    function beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
      if (isJPG) {
        showResult.value = false;
        compress(file);
      } else {
        ElMessage.error("Only .jpg/jpeg or .png file is aviliable");
      }
      return false;
    }
    function handleChange(file, list) {
      fileList.value = list.slice(-1);
    }
   
    return {
      beforeUpload,
 //     updateResult,
      isShow,
      handleChange,
      fileList,
    };
  },
};
</script>
